import React from "react";
import ReactDOM from "react-dom/client";
import "bootstrap/dist/css/bootstrap.min.css";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import {createBrowserRouter, RouterProvider} from "react-router";
import Transactions from "./screens/accounts/transactions-list/Transactions";
import MileageLogs from "./screens/cars/mileage-logs-list/MileageLogs";
import "moment/locale/fr";
import i18n from "i18next";
import {initReactI18next} from "react-i18next";
import SettingsRules from "./screens/settings/rules/list/SettingsRules";
import {Provider} from "react-redux";
import {store} from "./store";
import Settings from "./screens/settings/Settings";
import SettingsGeneral from "./screens/settings/general/SettingsGeneral";
import SettingsCategories from "./screens/settings/categories/list/SettingsCategories";
import Portfolio from "./screens/portfolio/list/Portfolio";
import PortfolioQuote from "./screens/portfolio/list/PortfolioQuote";
import SettingsTags from "./screens/settings/tags/list/SettingsTags";
import Dashboard from "./screens/dashboard/Dashboard";
import RequestResetPassword from "./screens/authentication/request-reset-password/RequestResetPassword";
import AuthenticationAction from "./screens/authentication/authentication-action/AuthenticationAction";
import Signin from "./screens/authentication/signin/Signin";
import Signup from "./screens/authentication/signup/Signup";
import SettingsAuthentication from "./screens/settings/authentication/SettingsAuthentication";
import SettingsAccounts from "./screens/settings/accounts/SettingsAccounts";
import SettingsPortfolio from "./screens/settings/portfolio/SettingsPortfolio";
import SettingsCars from "./screens/settings/cars/SettingsCars";
import SettingsSubscription from "./screens/settings/subscription/SettingsSubscription";
import Budgets from "./screens/budgets/Budgets";
import Support from "./screens/support/Support";
import Loans from "./screens/loans/loans-list/Loans";

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    lng: "fr",
    fallbackLng: "en",

    interpolation: {
      escapeValue: false
    }
  });

const root = ReactDOM.createRoot(document.getElementById("root"));

const router = createBrowserRouter([
  {
    path: "/",
    element: <App/>,
    children: [
      {path: "/", element: <Dashboard/>},
      {path: "/budgets", element: <Budgets/>},
      {path: "/transactions", element: <Transactions/>},
      {path: "/portfolio", element: <Portfolio/>},
      {path: "/portfolio/:symbol", element: <PortfolioQuote/>},
      {path: "/cars", element: <MileageLogs/>},
      {path: "/loans", element: <Loans/>},
      {path: "/support", element: <Support/>},
      {
        path: "/settings",
        element: <Settings/>,
        children: [
          {path: "/settings", element: <SettingsGeneral/>},
          {path: "/settings/transactions", element: <SettingsAccounts/>},
          {path: "/settings/portfolio", element: <SettingsPortfolio/>},
          {path: "/settings/cars", element: <SettingsCars/>},
          {path: "/settings/authentication", element: <SettingsAuthentication/>},
          {path: "/settings/transactions-categories", element: <SettingsCategories/>},
          {path: "/settings/transactions-rules", element: <SettingsRules/>},
          {path: "/settings/tags", element: <SettingsTags/>},
          {path: "/settings/subscription", element: <SettingsSubscription/>}
        ]
      }
    ]
  },
  {path: "/signin", element: <Signin/>},
  {path: "/signup", element: <Signup/>},
  {path: "/password", element: <RequestResetPassword/>},
  {path: "/auth/action", element: <AuthenticationAction/>}
]);

root.render(
  <Provider store={store}>
    <RouterProvider router={router}/>
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
